export default {
  SET_CLIENT_CONFIGURATIONS(state, configurations) {
    state.configurations = configurations;
  },
  SET_CLIENT_CONFIGURATION_FILTERS(state, filters) {
    state.filters = filters;
  },
};
